<template>
  <div class="h-2 w-full bg-gray-200" :class="{ 'my-2': spacing }">
    <div
      class="h-2 w-full transition-width duration-200"
      :class="css || 'bg-primary-500 '"
      :style="styleObject"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  data() {
    return {};
  },
  props: {
    amount: {
      value: 0,
      type: Number
    },
    spacing: {
      default: false,
      type: Boolean
    },
    css: {
      type: String,
      default: null
    }
  },
  components: {},
  methods: {},
  computed: {
    styleObject: function() {
      return { width: this.amount + "%" };
    }
  },
  created() {}
};
</script>
